import { driveCreativesCopy as t } from "./copy.ts";
import { place } from "./place.ts";

export const drawer = { label: t.lugar, href: place.path };
